var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6539_1404)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.25016 3.53331C8.82377 3.39905 9.41105 3.33193 10.0002 3.33331C15.8335 3.33331 19.1668 9.99998 19.1668 9.99998C18.661 10.9463 18.0577 11.8373 17.3668 12.6583M11.7668 11.7666C11.538 12.0123 11.262 12.2093 10.9553 12.3459C10.6486 12.4826 10.3176 12.556 9.98191 12.562C9.64623 12.5679 9.3128 12.5061 9.0015 12.3804C8.69021 12.2547 8.40743 12.0675 8.17004 11.8301C7.93264 11.5927 7.74549 11.3099 7.61975 10.9986C7.49402 10.6873 7.43227 10.3539 7.43819 10.0182C7.44411 9.68256 7.51759 9.35152 7.65423 9.04485C7.79087 8.73819 7.98787 8.46219 8.2335 8.23331M0.833496 0.833313L19.1668 19.1666M14.9502 14.95C13.5257 16.0358 11.7911 16.6374 10.0002 16.6666C4.16683 16.6666 0.833496 9.99998 0.833496 9.99998C1.87007 8.06823 3.30778 6.38049 5.05016 5.04998L14.9502 14.95Z",
    stroke: "#98A2B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6539_1404"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOff);
export default __webpack_public_path__ + "static/media/eye-off.3f9ba1cf3869c30a2623ef60d7839dca.svg";
export { ForwardRef as ReactComponent };